<template>
  <div class="invoice">
    <div class="title">纸质专用发票</div>
    <div class="tips">
      提示：修改或完善开票信息，请前往 发票管理->
      <span class="text-button clickable" @click="toInvoiceHelp">发票助手</span>
    </div>
    <div class="content">
      <div class="invoice-form">
        <el-form :model="form" label-width="160px" label-suffix="：">
          <el-form-item label="单位名称" prop="companyName">
            <span>{{ form.companyName || '-' }}</span>
          </el-form-item>
          <el-form-item label="纳税人识别号" prop="companyTaxNo">
            <span>{{ form.companyTaxNo || '-' }}</span>
          </el-form-item>
          <el-form-item label="注册地址" prop="companyAddress">
            <span>{{ form.companyAddress || '-' }}</span>
          </el-form-item>
          <el-form-item label="注册电话" prop="companyMobile">
            <span>{{ form.companyMobile || '-' }}</span>
          </el-form-item>
          <el-form-item label="开户银行" prop="companyBankName">
            <span>{{ form.companyBankName || '-' }}</span>
          </el-form-item>
          <el-form-item label="银行账号" prop="companyBankAccount">
            <span>{{ form.companyBankAccount || '-' }}</span>
          </el-form-item>
          <el-form-item label="收票人姓名" prop="employeeName">
            <span>{{ form.employeeName || '-' }}</span>
          </el-form-item>
          <el-form-item label="收票人手机号" prop="employeeMobile">
            <span>{{ form.employeeMobile || '-' }}</span>
          </el-form-item>
          <el-form-item label="收票人邮箱" prop="employeeEmail">
            <span>{{ form.employeeEmail || '-' }}</span>
          </el-form-item>
          <el-form-item label="邮寄地址" prop="receiveAddress">
            <span>{{ form.receiveAddress || '-' }}</span>
          </el-form-item>
          <el-form-item label="上传专票证明附件" prop="attachmentId">
            <upload
              v-if="form.attachmentId"
              ref="upload"
              :props-data="{
                bizType: 'invoice_paper',
                attachmentType: 'invoice_paper',
                groupIdBefore: form.attachmentId,
                disabled: true
              }"
            >
              <div slot="tip" class="important-tip m-t-10">
                支持：jpg、png、bmp、jpeg，图片大小不超过5M，只可上传1个
              </div>
            </upload>
            <span v-else>-</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from '@/components/common/Upload/index.vue'
// 工具
import { strUtil } from 'jczh-ui'
import { invoiceTypeDict, isCompanyDict } from '@/dictionary/financial'
import { getInvoiceApi } from '@/api/financial'

export default {
  name: 'SpecialInvoice',

  components: { Upload },

  filters: {
    bankFilter(bankCard) {
      return bankCard ? strUtil.bankCardDivision(bankCard) : '-'
    }
  },

  props: {
    companyId: {
      type: [String, Number],
      required: true
    },

    // 发票地址id
    invoiceAddressId: {
      type: [String, Number],
      default: ''
    },

    // 当前用户是否为企业员工
    isEmployee: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: {
        id: undefined,
        invoiceType: invoiceTypeDict.SPECIAL_PAPER_INVOICE.value,
        companyId: undefined,
        companyName: undefined,
        companyTaxNo: undefined,
        companyAddress: undefined,
        companyMobile: undefined,
        companyBankName: undefined,
        companyBankAccount: undefined,
        employeeName: undefined,
        employeeMobile: undefined,
        employeeEmail: undefined,
        receiveAddress: undefined,
        attachmentId: undefined,
        isCompany: isCompanyDict.COMPANY.value
      }
    }
  },

  created() {
    this.getInvoiceInfo()
  },

  methods: {
    // 获取发票信息
    getInvoiceInfo() {
      getInvoiceApi({
        type: invoiceTypeDict.SPECIAL_PAPER_INVOICE.value,
        companyId: this.companyId,
        invoiceAddressId: this.invoiceAddressId,
        isCompany: this.isEmployee
          ? isCompanyDict.COMPANY.value
          : isCompanyDict.PERSONAL.value
      })
        .then(res => {
          this.form = Object.assign({}, this.form, res.data)
          this.form.invoiceType = invoiceTypeDict.SPECIAL_PAPER_INVOICE.value

          this.$emit('getInvoiceInfo', this.form)
        })
        .catch(err => {
          console.error('获取发票信息失败', err)
          this.$message.error(err?.data?.message || '获取纸质专用发票信息失败')
        })
    },

    toInvoiceHelp() {
      this.$emit('toInvoiceHelp')
    }
  }
}
</script>

<style scoped lang="scss">
.invoice {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 20px;
    color: $text-color;
  }
  .tips {
    color: $third-text-color;
    margin: 8px 0 24px;

    .text-button {
      &:hover {
        color: $primary-color;
        opacity: 1;
      }
    }
  }
  .content {
    .invoice-form {
      display: flex;
      flex-direction: column;
      align-items: center;
      ::v-deep .el-form {
        width: 400px;
        .el-form-item {
          margin-bottom: 20px;
        }

        &.detail-form {
          .el-form-item {
            margin-bottom: 0;
          }
        }
      }

      .invoice-form-operate {
        text-align: center;
      }
    }

    .edit-tip-message {
      margin-bottom: 20px;
      color: $danger-color;
      font-size: 14px;
    }

    .download-file {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;
      color: $primary-color;
      font-size: 12px;
    }

    .important-tip {
      font-size: 12px;
      color: $second-text-color;
      line-height: 1.2;
    }

    .register-agreement {
      margin-bottom: 20px;

      .el-checkbox__label {
        line-height: 1;
        font-size: 12px;
      }

      .agreement-button {
        &::before {
          content: '《';
        }

        &::after {
          content: '》';
        }

        ::v-deep .el-button {
          padding: 0;
        }
      }
    }
  }
}
</style>
